import Api from 'api'

const config = {
  baseURL: '/api/app/v2/',
}
const api = new Api(config)

api.fetchChart = ({ accountExternalId, campaignId, network, ...rest }) =>
  api.get(
    `${network}/statistics/accounts/${accountExternalId}/campaigns/${campaignId}/dates`,
    { ...rest },
  )
api.fetchAds = ({ accountExternalId, campaignId, network, ...rest }) =>
  api.get(
    `${network}/statistics/accounts/${accountExternalId}/campaigns/${campaignId}/ads`,
    { ...rest },
  )

export default api
